import { useGlobals } from "@/components/providers/globals-provider.tsx";
import { Panel, PanelItem } from "@/components/ui/panel.tsx";
import TechnicalFiles from "@/features/downloads/components/technical-files.tsx";
import InterestingProjects from "@/features/interesting-projects/interesting-projects.tsx";
import { WebComponentMode } from "@/types";

export default function Ctas() {
    const { mode } = useGlobals();

    return (
        <Panel className="configuration-panel__footer">
            <PanelItem asChild>
                <TechnicalFiles />
            </PanelItem>
            {mode === WebComponentMode.Website && (
                <PanelItem asChild>
                    <InterestingProjects />
                </PanelItem>
            )}
        </Panel>
    );
}
